import './App.css';
import { useEffect } from 'react';
import { UserProvider } from './context/UserContext';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './components/AppRoutes';
import { applyLoadingBackgroundFromStorage } from './utils/loadingBackground';

const AppWithLegalPerson = () => {
  useEffect(() => {
    applyLoadingBackgroundFromStorage();
  }, []);

  return (
    <UserProvider>
      <AppRoutes />
    </UserProvider>
  );
};

const App = () => (
  <Router>
    <AppWithLegalPerson />
  </Router>
);

export default App;
